import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import {T} from '../../components/I18n';

import TimeAgo from '../../components/TimeAgo';
import Card from '../../components/Card';
import Avatar from '../../components/Avatar';
import ListItem from '../../components/ListItem';
import Error from "../../components/Error";

function SheetActivityList({sheets, options, pagination}) {
  return (
    <Card>
      <Card.Title options={options}>Activity</Card.Title>
      {sheets.length > 0 ?
        sheets.map(sheet => (
          <ListItem
            key={sheet.id}
            avatar={<Avatar user={sheet.user}/>}
            title={sheet.template.name}
            subtitle={
              <T isolate>Updated <TimeAgo date={sheet.dates.lastModified}/> by <Link
                to={`/users/${sheet.user.id}`}><T variable="username">{sheet.user.userName}</T></Link></T>
            }
            options={[
              {title: 'View', to: `/sheet/${sheet.templateId || sheet.template.id}/${sheet.id}`}
            ]}>
            <FormTitle><T noTranslate>{sheet.template.name}</T></FormTitle>
            <SheetTitle sheet={sheet}>{sheet.name ? <T noTranslate>{sheet.name}</T> : "Unnamed sheet"}</SheetTitle>
          </ListItem>
        )) : (
          <Error halfScreen message="No sheets to show"/>
        )}
      {sheets.length > 0 && <PaginationContainer>{pagination}</PaginationContainer>}
    </Card>
  );
}

const FormTitle = styled.strong`
  display: block;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`;

const SheetTitle = styled.small`
  display: block;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${props => props.sheet.name ? '#4e4e4e' : '#747474'};
  font-weight: ${props => props.sheet.name ? '500' : 'normal'};
`;

const PaginationContainer = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: center;
  border-top: 1px solid #e4e4e4;
`;

export default SheetActivityList;